module.exports = __webpack_public_path__ + "img/blue_072.c687dc8c.png";